import i18n from "src/app/shared/localization/i18n";
export const MIN_LOGIN_LENGHT: number = 6;
export const MIN_PASSWORD_LENGHT: number = 6;
export const MAX_LOGIN_LENGTH: number = 40;


export const CONFIRM_PASSWORD_NOT_MATCH_MESSAGE: string = i18n.t('license.confirmPasswordNotMatchMessage');
export const UNKNOWN_ERROR_MESSAGE: string = i18n.t('license.unknownErrorMessage');
export const LICENSE_ERROR_MESSAGE: string = i18n.t('license.licenseErrorMessage');
export const UPDATE_LICENSE_SUCCESS_MESSAGE: string = i18n.t('license.updateLicenseSuccessMessage');
export const UPDATE_LICENSE_ERROR_MESSAGE: string = i18n.t('license.updateLicenseErrorMessage');
